import React from "react";
import SearchIcon from "../../../Icons/SearchIcon";
export interface SearchFieldProps extends React.HTMLProps<HTMLInputElement> {
  icon?: React.ReactNode;
  type?: "text" | "search";
  containerClass?: string;
  mode?: "history" | "request" | "application";
}

const SearchField = ({
  type = "text",
  className,
  containerClass,
  ...rest
}: SearchFieldProps) => {
  return (
    <div
      className={`form-control mb-5 flex w-full flex-row items-center border-b dark:border-theme-color-light ${containerClass}`}
    >
      <label className="label">
        <SearchIcon />
      </label>
      <input
        required
        type={type}
        {...rest}
        className={`input-bordered input-ghost input input-lg w-full rounded-none border-none border-primary bg-transparent px-1 placeholder:text-xs focus:outline-none md:placeholder:text-base ${className}`}
      />
    </div>
  );
};

export default SearchField;
